import React, { useState } from 'react';
import { FormProvider } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import AddressDialog from 'components/AddressDialog/AddressDialog';
import AddressItem from 'components/AddressItem/AddressItem';
import Spinner from 'components/Spinner/Spinner';
import { Header } from 'components/Text';
import AddressTypes from 'constants/addressTypes';
import useAgreementAddress from 'hooks/agreements/useAgreementAddress';
import useAddressForm from 'utils/form/useAddressForm';
export default function AgreementAddress({
  open,
  onClose,
  shipping,
  address
}) {
  const {
    t
  } = useTranslation();
  const {
    isLoading,
    changeAgreementAddress
  } = useAgreementAddress();
  const [error] = useState(false);
  const addressType = shipping ? AddressTypes.SHIPPING : AddressTypes.BILLING;
  const addressTypeTag = shipping ? 'shipping' : 'billing';
  const formMethods = useAddressForm(address);
  const onSave = (addressEl, updatedAddress) => {
    changeAgreementAddress(addressEl, updatedAddress);
  };
  const handleSubmit = () => {
    formMethods.handleSubmit(data => {
      onSave(addressType, data);
      onClose();
    });
  };
  if (isLoading) return /*#__PURE__*/React.createElement(Spinner, null);
  return /*#__PURE__*/React.createElement("div", null, address && /*#__PURE__*/React.createElement(Header, null, t(`address.${addressTypeTag}_address`), " ", t('address.for_agreement')), /*#__PURE__*/React.createElement(AddressItem, {
    address: address,
    title: t('profile.edit_address'),
    addressType: addressType,
    onSave: onSave,
    isLoading: isLoading
  }), /*#__PURE__*/React.createElement(FormProvider, formMethods, /*#__PURE__*/React.createElement(AddressDialog, {
    open: open,
    onClose: onClose,
    isLoading: isLoading,
    dialogTitle: t(`agreements.edit.edit_${addressTypeTag}`),
    primaryBtnClickIsDisabled: !formMethods.formState.isValid || error || isLoading,
    onPrimaryBtnClick: handleSubmit,
    primaryBtnTitle: t('buttons.save'),
    subtitle: t(`agreements.edit.${addressTypeTag}_description`)
  })));
}
AgreementAddress.defaultProps = {
  shipping: false
};